// moved here to avoid import/no-cycle
export const PLAYLISTS_FETCH_LIST_SUCCESS = 'Playlists/FETCH_LIST_SUCCESS';
